import { URLHandler } from "src/services/URLHandler";

const GLOBAL_SETTINGS_ROUTE_PREFIXES = [
    "/settings/cms",
    "/settings/companies",
    "/settings/providers",
    "/settings/roles",
    "/settings/configuration/access-permissions/roles",
    "/settings/configuration/customization-languages/app-blocks",
    "/settings/my-organization/companies-suppliers/companies",
    "/settings/my-organization/companies-suppliers/suppliers",
] as const;

const GLOBAL_SETTINGS_ROUTES = [
    "/settings",
    "/settings/my-organization",
    "/settings/my-organization/companies-suppliers",
] as const;

const isPathWithin = (pathname: string, routePrefix: string) =>
    pathname === routePrefix || pathname.startsWith(`${routePrefix}/`);

export const requiresCompanyContext = (pathname: string) =>
    pathname !== URLHandler.login.noCompany() &&
    !GLOBAL_SETTINGS_ROUTES.includes(pathname as (typeof GLOBAL_SETTINGS_ROUTES)[number]) &&
    !GLOBAL_SETTINGS_ROUTE_PREFIXES.some((routePrefix) => isPathWithin(pathname, routePrefix));
